import React, { useContext, useState } from 'react';
import { useMutation } from '@apollo/client';
import { ModalBottomButtonContainer } from './Styles';
import { BlurTextField } from '../connectedForm/inputComponents';
import { DangerButton, SecondaryButton, SuccessButton } from '../connectedForm/Button';
import ModalContext from '../Context/ModalContext';
import SalesInvoiceCreatePayByLink from '../../graphql/mutations/salesLedger/SalesInvoiceCreatePayByLink.graphql';
import { useComponentQueryErrorHandling } from '../../utils/parseErrorResponse';
import getClientMutationId from '../../utils/getClientMutationId';
import { BlurTextFieldType } from '../connectedForm/BlurTextField/BlurTextField';
import { BasicHeader } from '../../actions/BasicHeader';
import FluentModal from './FluentModal';

type PayByLinkModalProps = {
  open: boolean;
  paymentAmount: number;
  invoiceId: number;
};

const PayByLinkModal = ({ open, paymentAmount: defaultPaymentAmount, invoiceId }: PayByLinkModalProps) => {
  const { onClose: onModalClose } = useContext(ModalContext);
  const handleQueryError = useComponentQueryErrorHandling();

  const [paymentAmount, setPaymentAmount] = useState(defaultPaymentAmount);
  const [paymentLink, setPaymentLink] = useState(null);

  const [createPayment, { loading }] = useMutation(SalesInvoiceCreatePayByLink, {
    onError: handleQueryError,
  });

  const onConfirm = () => {
    createPayment({
      variables: {
        input: {
          clientMutationId: getClientMutationId(),
          salesInvoiceId: invoiceId,
          amount: paymentAmount,
        },
      },
    }).then((response) => {
      setPaymentLink(response.data?.salesInvoiceCreatePayByLink.result);
    });
  };

  const renderPayment = () => {
    return (
      <>
        <div style={{ padding: '1em' }}>
          <BlurTextField
            data-testid={'pay-by-link-payment-amount'}
            label="Payment Amount"
            type={BlurTextFieldType.Currency}
            decimals={2}
            value={paymentAmount}
            onChange={setPaymentAmount}
            mandatory
            enableOnChange
          />
        </div>
        <ModalBottomButtonContainer>
          <SuccessButton inline onClick={onConfirm} disabled={loading}>
            Confirm
          </SuccessButton>
          <DangerButton inline onClick={onModalClose} disabled={loading}>
            Cancel
          </DangerButton>
        </ModalBottomButtonContainer>
      </>
    );
  };

  const renderPaymentLink = () => {
    return (
      <>
        <div style={{ padding: '1em' }}>
          <p>Please direct payee to the following URL:</p>
          <BlurTextField
            data-testid={'pay-by-link-direct-payee-to-url'}
            includeLabel={false}
            value={paymentLink!}
            mandatory
            enableOnChange
            readOnly
            copy
          />
        </div>
        <ModalBottomButtonContainer>
          <SecondaryButton inline onClick={onModalClose}>
            Close
          </SecondaryButton>
        </ModalBottomButtonContainer>
      </>
    );
  };

  return (
    <FluentModal isOpen={open} styles={{ main: { paddingBottom: '60px' } }}>
      <BasicHeader>Pay By Link</BasicHeader>
      {paymentLink ? renderPaymentLink() : renderPayment()}
    </FluentModal>
  );
};

export default PayByLinkModal;
